module.exports = __webpack_public_path__ + "static/img/no-begin.26d47b51.png";